import { CalendarEventStyle } from "components/Calendar/types";
import { Meeting } from "../Meeting/models";
import { fromActionPrefixId } from "./helpers";
import { ActionSummaryData, ActionType, ActionV2 } from "./models";

export function lightActionStyleByType(
  actionType: ActionType,
  action: ActionV2 | ActionSummaryData,
): CalendarEventStyle & { displayActionType: string } {
  switch (actionType) {
    case "task":
      return {
        displayActionType: "TASK",
        bg: "cdsOrange.200",
      };
    case "message":
      return {
        displayActionType: "MESSAGE",
        bg: "cdsIndigo.200",
      };
    case "meeting": {
      const meeting = action as Meeting;
      const meetingType = meeting.meetingType;
      const border = meeting.status === "pending_scheduling" ? "2px dashed #000" : undefined;
      const opacity = meeting.status === "pending_scheduling" ? 0.3 : 1;
      if (meetingType === "group_session_adhoc") {
        return {
          displayActionType: "MEETING",
          bg: "groupBlue.400",
          border,
          opacity,
        };
      } else if (meetingType === "group_session_recurring") {
        return {
          displayActionType: "MEETING",
          bg: "linkBlue.500",
          border,
          opacity,
        };
      } else if (meetingType === "individual") {
        return {
          displayActionType: "MEETING",
          bg: "singlePink.400",
          border,
          opacity,
        };
      }
      return {
        displayActionType: "MEETING",
        bg: "meetingBlue.light",
      };
    }
    case "email":
      return {
        displayActionType: "EMAIL",
        bg: "brand.200",
      };
    case "checkpoint":
      return {
        displayActionType: "CHECKPOINT",
        bg: "cdsIndigo.200",
      };
    default:
      return { displayActionType: "" };
  }
}

export function lightActionStyles(action: ActionV2 | ActionSummaryData): CalendarEventStyle {
  const { resourceType } = fromActionPrefixId(action.prefixId);
  return lightActionStyleByType(resourceType as ActionType, action);
}
